import { Component, Input, OnInit } from '@angular/core';
import { Cell } from 'angular2-smart-table'
@Component({
  selector: 'app-fake-name-cell',
  template: `{{ displayValue }}`
})
export class FakeNameCellComponent implements OnInit {
  @Input() value: any;
  @Input() rowData: any;
  @Input() rowIndex: number;
  @Input() row: any;
  @Input() grid: any;

  // Parent function passed as Input
  @Input() hideNamesFn: (row: any) => string;

  displayValue: string = '';

  ngOnInit() {
    
    
  }

 initialize(_cell) {
    console.log("=----------------- _row is ", _cell)
    this.displayValue = this.hideNamesFn?.(_cell.row) ??  'xx';
  }
}
